window.sq = window.sq || {};
window.sq.initSearch = (store) => {
  console.log("Dropdown Search");
  store.search();
};


(function (XHR) {
    "use strict";

    var originalOpen = XHR.prototype.open;
    var originalSend = XHR.prototype.send;

    XHR.prototype.open = function (method, url, async, user, pass) {
        this._url = url; // Save the URL for later use
        originalOpen.call(this, method, url, async, user, pass);
    };

    XHR.prototype.send = function (data) {
        var url = this._url;
        let location = window.location.href;
        
        if (url.toLowerCase() === "https://bfmtj1brh4prmapq124rw49m.fast.sparq.ai/v2".toLowerCase()) {
            let body;
            try {
                body = JSON.parse(data);
            } catch (error) {
                console.error("Error parsing XHR data as JSON:", error);
                // If parsing fails, just proceed to send the original data
                originalSend.call(this, data);
                return;
            }

            // Extract collection handle from URL if present
            let collectionHandle = location.includes("/collections/") ? location.split("/collections/")[1].split("?")[0] : null;

            // Proceed only if we're not on a search or all page and collectionHandle is found
            if (!location.includes("/search") && !location.includes("/all") && collectionHandle) {
                let collectionHandleFormatted = `sortOrderFor_${collectionHandle.replaceAll("-", "_")}`;
                let sorting = body.sort || [];

                // Add collection-specific sortOrder if not already included
                if (!sorting.includes(collectionHandleFormatted)) {
                    sorting.push(collectionHandleFormatted);
                }

                // Update the sort order
                body.sort = sorting;

                // Convert the modified body back to a JSON string
                data = JSON.stringify(body);
            }
        }

        // Proceed to send the (possibly modified) data
        originalSend.call(this, data);
    };
})(XMLHttpRequest);


// (function (XHR) {
//   "use strict";
//   var open = XHR.prototype.open;
//   var send = XHR.prototype.send;

//   const forcedTag = "tags_watch_uauvfho7gxa6sfwl2f38q5uu";

//   XHR.prototype.open = function (method, url, async, user, pass) {
//     this._url = url;
//     open.call(this, method, url, async, user, pass);
//   };

//   XHR.prototype.send = function (data) {
//     var url = this._url;

//     if (
//       url &&
//       url.toLowerCase() ===
//         "https://bfmtj1brh4prmapq124rw49m.fast.sparq.ai/v2".toLowerCase()
//     ) {
//       const body = JSON.parse(data);

//       // Extract user-selected sorts except the forced tag
//       let userSorts = Array.isArray(body.sort)
//         ? body.sort.filter((s) => s !== forcedTag)
//         : [];

//       if (userSorts.length > 0) {
//         // User has selected sorts — replace entire sort array with those
//         body.sort = userSorts;
//       } else {
//         // No user-selected sorts — default to forced tag only
//         body.sort = [forcedTag];
//       }

//       data = JSON.stringify(body);
//     }

//     send.call(this, data);
//   };
// })(XMLHttpRequest);

function toggleFilter() {
  let x = document.querySelector(".sq-filter-main");
  x.classList.toggle("opening");
}
function toggleClass() {
  let y = document.querySelector(".sq-filter-main");
  y.classList.remove("opening");
}
function removeClass() {
  let z = document.querySelector(".sq-filter-main");
  z.classList.remove("opening");
}

window.addEventListener("load", () => {
  setTimeout(()=>{
     window.sq.showFilter();
  
  if (window.matchMedia("(max-width: 767px)").matches) {
   if(!document.getElementById("Search-In-Modal")) return;
    document
      .getElementById("Search-In-Modal")
      .addEventListener("focusin", () => {
        document.querySelector(".sq-dropdown-body").style.maxHeight = "100%";
      });
    document
      .getElementById("Search-In-Modal")
      .addEventListener("focusout", () => {
        document.querySelector(".sq-dropdown-body").style.maxHeight = "0px";
      });
  }
      },200);
});

 window.sq.showFilter = function () {
  if(document.querySelector(".sparq-row-base")) document.querySelector(".sparq-row-base").style.visibility = null;
  if(document.querySelector(".sq-filter-main")) document.querySelector(".sq-filter-main").style.visibility = null;
  if(document.querySelector(".custom-filter")) document.querySelector(".custom-filter").style.visibility = null;
  if(document.querySelector(".sq-filter-header-title")) document.querySelector(".sq-filter-header-title").style.visibility = null;

 }
window.onload = function () {
  setTimeout(()=>{
   
    document.querySelectorAll(".sq-accordion-header.sq-cursor-pointer").forEach(el=>{
      if(el.classList.contains("sq-open"))el.click();
      el.removeEventListener('click', sidebarToggleFnc)
      el.addEventListener('click', sidebarToggleFnc)
  });
    sidebarToggleFnc();
    document.querySelector(".sq-filter-group-price .sq-accordion")?.classList.add("sq-active");
      document.querySelector(".sq-filter-group-sort .sq-accordion")?.classList.add("sq-active");
  },1000)

}
function sidebarToggleFnc(el) {
  let sidebar = document.querySelector(".sq-filter-main");
   if(sidebar) sidebar.querySelectorAll(".sq-accordion").forEach(ele=>{
    ele.classList.remove("sq-active");
  })
  if(el) el.target.parentElement.classList.toggle("sq-active");
}

function sortOnClickValue(){
    // Get all the option labels
  const optionLabels = document.querySelectorAll('.value-picker__choice-item');

  // Add a click event listener to each label
  optionLabels.forEach(label => {
    label.addEventListener('click', () => {
      // Remove the "selected" class from all the labels
      optionLabels.forEach(ele => {
        console.log("Hi");
        ele.classList.remove('selected');
      });

      // Add the "selected" class to the clicked label
      
      label.classList.add('selected');
    });
  });
}

document.addEventListener("keyup",(e)=>{
  if(e.key=="Escape"){
    document.querySelector(".sq-dropdown-body").style.maxHeight="0px";
    document.querySelector(".sq-filter-main").click()
  }
})
window.sq.discount = function (item, filters) { 
  console.log(item)
  const discountFilter = filters.find(x => x.stFieldName.toLowerCase() === 'discount');

  if(discountFilter) {
    discountFilter.items[0].displayLabel = "Below - 10%";
    discountFilter.items[1].displayLabel = "10% - 20%";
    discountFilter.items[2].displayLabel = "20% - 30%";
    discountFilter.items[3].displayLabel = "30% - 40%";
    discountFilter.items[4].displayLabel = "40% - 50%";
    discountFilter.items[5].displayLabel = "50% - Above";
  };  
  
  return filters;
}

// window.sq.getItems = function(items){
//   var sys_tags = items.system_tags;
//   // sys_tags.forEach(tag=>{
//   //   console.log(tag)
//   // })
//   console.log(sys_tags.length);

//   // for(var i=0; i<sys_tags.length; i++){
//   // }
//    console.log(sys_tags.find((ele) => ele.contains("sort_")))

  
//   return true;
// }

// window.sq.check = function(){
//   console.log("check")
//   var element = document.querySelector('.sq-filter-group-price .sq-accordion');

//   if (!element.classList.contains('sq-open')) {
//     element.click();
//   }

// // checkAndClick(divElement);

// }


document.body.addEventListener("click",e=>{
  if(window.innerWidth < 767)
  if(e.target.classList.contains("sq-accordion-header") && e.target.closest(".sq-filter-group-price")){
    // console.log(e.target.parentElement);
    let parentElement = e.target.parentElement;
    if(parentElement.classList.contains("sq-close")){
      e.target.click();
      setTimeout(()=>{
        e.target.closest(".sq-accordion").classList.add("sq-active");
      },10)
    }
  }
})

//to toggle the search bar when clicking other the cross in search container
// window.onload = function(){
// const searchContainer = document.querySelector('#HeaderSearchForm');
	
//       document.addEventListener('click', function(event) {
// 	    if (document.querySelector(".site-header__search-container").classList.contains("is-active") && !searchContainer.contains(event.target)) {
// 	      document.querySelector("#SearchClose").click();     
// 	    }
// 	});

// }





